module.exports = __webpack_public_path__ + "img/brand-23.78d389db.png";